/** Formata densidade para exibição no formato 0.000 */
export const formatDensity = (val) => {
  if (val === "" || val == null || String(val).trim() === "") return "";
  const n = parseFloat(val);
  if (Number.isNaN(n)) return val;
  return n.toFixed(3);
};

/** Obtém a quantidade de elementos a partir da voltagem nominal (24V→12, 48V→24). */
export const getBatteryElementCountFromVoltage = (voltagemNominal) => {
  if (!voltagemNominal && voltagemNominal !== 0) return 24;
  const v = parseFloat(voltagemNominal);
  if (v <= 24) return 12;
  return 24;
};

/** Infere quantidade de elementos pelos dados reais - maior índice com voltage ou density preenchido */
export const inferElementCountFromBatteryData = (battery) => {
  if (!battery) return 24;
  let maxIdx = 0;
  for (let i = 1; i <= 24; i++) {
    const v = battery[`element_${i}_voltage`];
    const d = battery[`element_${i}_density`];
    const hasV = v !== "" && v != null && String(v).trim() !== "";
    const hasD = d !== "" && d != null && String(d).trim() !== "";
    if (hasV || hasD) maxIdx = i;
  }
  if (maxIdx > 0) return maxIdx;
  return getBatteryElementCountFromVoltage(
    battery.voltagem_nominal ?? battery.total_voltage
  );
};

/** Infere quantidade de elementos a partir da tensão total medida (criação) */
export const inferElementCountFromVoltage = (totalVoltage) => {
  if (!totalVoltage && totalVoltage !== 0) return 24;
  const v = parseFloat(totalVoltage);
  if (v < 30) return 12;
  return 24;
};

/** Converte bateria do backend para formato do formulário */
export const batteryToFormState = (battery) => {
  const elementCount = inferElementCountFromBatteryData(battery);
  const elements = Array.from({ length: elementCount }, (_, idx) => ({
    voltage: battery?.[`element_${idx + 1}_voltage`] ?? "",
    density: formatDensity(battery?.[`element_${idx + 1}_density`]) ?? ""
  }));
  return {
    brand: battery?.pat || battery?.brand || "",
    manufactureDate: battery?.manufacture_date || "",
    readingDate: battery?.reading_date || "",
    totalVoltage: battery?.total_voltage || "",
    elementCount,
    elements
  };
};

/** Bateria vazia para criação */
export const emptyBatteryFormState = () => ({
  brand: "",
  manufactureDate: "",
  readingDate: "",
  totalVoltage: "",
  elementCount: 24,
  elements: Array.from({ length: 24 }, () => ({ voltage: "", density: "" }))
});
